/**
 * The Idempotency-Key for a batch submit: a per-dialog nonce plus a digest
 * of the payload. The same form resubmitted unchanged (a retry after a lost
 * response) returns the batch the first attempt created; an edited form
 * gets a fresh key and so a fresh batch; another dialog never collides with
 * this one even on an identical payload.
 */

import type { BatchCreate } from '@/api/generated/model'

export async function idempotencyKeyFor(nonce: string, payload: BatchCreate): Promise<string> {
  const bytes = new TextEncoder().encode(JSON.stringify(payload))
  const digest = await crypto.subtle.digest('SHA-256', bytes)
  const hex = Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, '0')).join(
    '',
  )
  // A 36-char nonce, a separator and 32 hex chars stay inside the API's 128.
  return `${nonce}:${hex.slice(0, 32)}`
}
